import request from '@/utils/request';

export type LoginParamsType = {
  loginName: string;
  password: string;
}

export type ssoLoginParamsType = {
  satoken: string;
}



export async function getFakeCaptcha(mobile: string) {
  return request(`/api/login/captcha?mobile=${mobile}`);
}

export async function login(params: LoginParamsType): Promise<any> {
  return request('/mng/login',{
    method: 'POST',
    data: params,
  });
}
export async function ssoLogin(params: ssoLoginParamsType): Promise<any> {



  return request('/mng/sso_login', {
    method: 'POST',
    data: params,
  });
}


export async function logout(): Promise<any> {
  return request('/mng/logout',{
    method: 'POST',
  });
}


